(function () {
  const VARIANT_CHANGE_DELAY_MS = 50;

  function isValuePackOption(value) {
    const normalized = (value || '').toLowerCase();
    return normalized === 'value pack' || normalized.includes('باقة التوفير');
  }

  function getConfig() {
    const configEl = document.getElementById('filter-pack-variant-description-config');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      console.warn('[filter-pack-variant-description] Invalid config JSON', error);
      return null;
    }
  }

  function getDescriptionEl(sectionId) {
    return document.getElementById(`ProductDescription-${sectionId}`);
  }

  function isValuePackSelected(sectionId) {
    const picker = document.querySelector(
      `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
    );
    if (!picker) return false;

    const checkedRadio = picker.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return isValuePackOption(checkedRadio.value);

    const select = picker.querySelector('select');
    if (select && select.options[select.selectedIndex]) {
      return isValuePackOption(select.options[select.selectedIndex].textContent);
    }

    return false;
  }

  function initFilterPackVariantDescription() {
    const config = getConfig();
    if (!config || !config.sectionId || !config.filterPackHtml || !config.valuePackHtml) return;

    const sectionId = String(config.sectionId);
    const descriptionEl = getDescriptionEl(sectionId);
    if (!descriptionEl) return;

    const filterPackHtml = config.filterPackHtml;
    const valuePackHtml = config.valuePackHtml;

    function applyDescription() {
      const showValuePack = isValuePackSelected(sectionId);
      const nextHtml = showValuePack ? valuePackHtml : filterPackHtml;
      if (descriptionEl.innerHTML !== nextHtml) {
        descriptionEl.innerHTML = nextHtml;
      }
    }

    const picker = document.querySelector(
      `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
    );

    if (picker) {
      picker.addEventListener('change', () => {
        setTimeout(applyDescription, VARIANT_CHANGE_DELAY_MS);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data && event.data.sectionId && String(event.data.sectionId) !== sectionId) return;
        setTimeout(applyDescription, VARIANT_CHANGE_DELAY_MS);
      });
    }

    applyDescription();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterPackVariantDescription);
  } else {
    initFilterPackVariantDescription();
  }
})();
